
<!-- MODAL POPUP -->
<div class="modal fade" id="lessonstatmodal" data-keyboard="false" data-backdrop="static" tabindex="100" aria-hidden="true" role="dialog">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h3 class="modal-title">Lesson stats</h3>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body pt-0">        
        <div *ngIf="isLessonStatLoading else loadtemplate">          
          loading data...
        </div>  
        <ng-template #loadtemplate>
          <div class="text-center"
            [ngStyle]="{'background-color': lessonStat?.passed ? '#98fb98' : !lessonStat?.passed && hasAnyLessonStarted(lessonStat?.lessons) ? '#FFA756' : '#ec4848ff'}">
            {{lessonStat?.passed ? 'Passed' : !lessonStat?.passed && hasAnyLessonStarted(lessonStat?.lessons) ? 'Not Passed' : 'No Lesson Completed'}}
          </div>
          <p>Score Percentage: {{lessonStat?.scorePercentage}}%</p>
          <p>Attendance Percentage: {{lessonStat?.attendancePercentage}}%</p>
          <app-milestone 
            [activateLessonDeadlineNotification]="lessonStat?.activateLessonDeadlineNotification" 
            [lessons]="lessonStat?.lessons"
            [enrolledDate]="lessonStat?.enrolledDate"
          >
          </app-milestone>
        </ng-template>      
        <div class="d-flex justify-content-center flex-wrap gap-1.5 mt-3">
          <button type="button" class="btn m-0" data-dismiss="modal">Done</button>
        </div>
      </div>
    </div>
  </div>
</div>

<section class="overview" *ngIf="moduleStats?.activeStudentsCount > 0">

  <div class="statcards">
    <div class="statcard" *ngFor="let card of summaryCards">
      <span class="statcard__icon" [ngClass]="'statcard__icon--' + card.tone">
        <i [ngClass]="card.icon" aria-hidden="true"></i>
      </span>
      <div class="statcard__body">
        <div class="statcard__label">{{card.label}}</div>
        <div class="statcard__value">{{card.value}}</div>
        <div class="statcard__note">{{card.note}}</div>
      </div>
    </div>
  </div>

</section>
<app-tablelayout 
    [data]="students" 
    [filterItems]="filterOptions" 
    [count]="count"
    [columns]="columns"
    [columnsToRemove]="removeColumn"
    [offset]="25" 
    [noRecordText]="noStudentText"
    (loadDataEvent)="loadTableData($event)"
    (rowClicked)="rowClicked($event)"
    >
<app-tablelayout/>

